import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=4e272bcc&scoped=true&"
import script from "./PermissionsTable.vue?vue&type=script&lang=js&"
export * from "./PermissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&id=4e272bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e272bcc",
  null
  
)

export default component.exports